/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Matches backend Permission enum */
export enum Permission {
  Admin = "Admin",
  Backoffice = "Backoffice",
  DWG = "DWG",
  Trapezoids = "Trapezoids",
  Quantities = "Quantities",
  RealTimeMounting = "RealTimeMounting",
  Dimensions = "Dimensions",
  Holes = "Holes",
  Tags = "Tags",
  ProjectSave = "ProjectSave",
  ProjectLoad = "ProjectLoad",
  Electric = "Electric",
}

export interface BackofficeLoginRequest {
  organizationName: string;
  username: string;
  /** @format password */
  password: string;
}

export interface BackofficeLoginResponse {
  organization: Organization;
  /** JWT token */
  token: string;
}

export interface Organization {
  name: string;
  tokens: number;
  permissionsGroup: PermissionGroup[];
  /** Flattened permissions derived from groups */
  permissions?: Permission[];
}

export interface PermissionGroup {
  name: string;
  permissions: Permission[];
}

export interface User {
  organization: string;
  username: string;
  password: string;
  windowsCredentials?: string | null;
  /** Current JWT associated with user session */
  authorization?: string | null;
}

export interface Activity {
  organization?: string;
  username?: string;
  description?: string;
  /**
   * Epoch milliseconds
   * @format int64
   */
  timestamp?: number;
}

export interface ExceptionRecord {
  projectId?: string;
  organization?: string;
  username?: string;
  description?: string;
  /**
   * Epoch milliseconds
   * @format int64
   */
  timestamp?: number;
}

export interface AnalyticsSummary {
  totalUsers?: number;
  totalActivities?: number;
  totalExceptions?: number;
  activeUsers?: number;
}

export interface UserActivitySummary {
  username?: string;
  organization?: string;
  totalActivities?: number;
  /**
   * Epoch milliseconds
   * @format int64
   */
  lastActivity?: number;
  /**
   * Epoch milliseconds
   * @format int64
   */
  firstActivity?: number;
}

export interface ActivityCounts {
  totalActivities?: number;
  activitiesToday?: number;
  activitiesThisWeek?: number;
  activitiesThisMonth?: number;
}

export interface ActivityTrend {
  /**
   * Epoch milliseconds
   * @format int64
   */
  date?: number;
  count?: number;
}

export interface UserActivity {
  username?: string;
  count?: number;
}

export interface OrganizationStats {
  organization?: string;
  users?: number;
  activities?: number;
}

export interface Properties {
  minVersion: string;
  maxVersion: string;
}

export interface Project {
  id: string;
  organization: string;
  name: string;
  location: string;
  createdBy: string;
  /** @format int64 */
  creationTime: number;
  lastUpdatedBy: string;
  /** @format int64 */
  lastUpdatedTime: number;
}

export interface ContactRequest {
  name: string;
  companyName: string;
  /** @format email */
  email: string;
  phone: string;
  /** Optional message/content */
  content?: string | null;
}

export interface ProjectAnalytics {
  totalProjects?: number;
  projectsThisMonth?: number;
  projectsToday?: number;
  projectsThisYear?: number;
  projectsByOrganization?: {
    organization?: string;
    total?: number;
    thisMonth?: number;
    thisYear?: number;
    today?: number;
  }[];
  projectsByUser?: {
    user?: string;
    count?: number;
  }[];
  projectsByMonth?: {
    month?: string;
    count?: number;
  }[];
  recentProjects?: {
    id?: string;
    organization?: string;
    name?: string;
    location?: string;
    createdBy?: string;
    /** @format int64 */
    creationTime?: number;
    lastUpdatedBy?: string;
    /** @format int64 */
    lastUpdatedTime?: number;
  }[];
  exportStats?: {
    totalExports?: number;
    exportsThisMonth?: number;
    exportsToday?: number;
  };
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://localhost:9090";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title EnerJet Backoffice API
 * @version 1.0.0
 * @baseUrl http://localhost:9090
 *
 * Admin backoffice API for managing organizations, permission groups, users, and viewing analytics.
 *
 * Security: All endpoints require JWT Bearer authentication. Admin-only routes are marked with `x-permission-group: admin`.
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  contact = {
    /**
     * @description Public endpoint for contact form submissions. No authentication required.
     *
     * @tags backoffice
     * @name SubmitContact
     * @summary Submit contact form
     * @request POST:/contact
     */
    submitContact: (data: ContactRequest, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/contact`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  login = {
    /**
     * No description
     *
     * @tags backoffice
     * @name Login
     * @summary Login with organization, username, password and windows credentials
     * @request POST:/login
     */
    login: (data: BackofficeLoginRequest, params: RequestParams = {}) =>
      this.request<BackofficeLoginResponse, void>({
        path: `/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  organizations = {
    /**
     * No description
     *
     * @tags backoffice
     * @name ListOrganizations
     * @summary List organizations
     * @request GET:/organizations
     */
    listOrganizations: (params: RequestParams = {}) =>
      this.request<Organization[], any>({
        path: `/organizations`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name CreateOrganization
     * @summary Create organization
     * @request POST:/organizations
     */
    createOrganization: (data: Organization, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organizations`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name GetOrganization
     * @summary Get organization by name
     * @request GET:/organizations/detail
     */
    getOrganization: (
      query: {
        /** Organization unique name */
        organizationName: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Organization, void>({
        path: `/organizations/detail`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name UpdateOrganization
     * @summary Update organization
     * @request PUT:/organizations/detail
     */
    updateOrganization: (
      query: {
        /** Organization unique name */
        organizationName: string;
      },
      data: Organization,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organizations/detail`,
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name DeleteOrganization
     * @summary Delete organization
     * @request DELETE:/organizations/detail
     */
    deleteOrganization: (
      query: {
        /** Organization unique name */
        organizationName: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organizations/detail`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name UpdateOrganizationPermissionGroups
     * @summary Replace organization permission groups
     * @request PUT:/organizations/permission-groups
     */
    updateOrganizationPermissionGroups: (
      query: {
        /** Organization unique name */
        organizationName: string;
      },
      data: PermissionGroup[],
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organizations/permission-groups`,
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name ListUsers
     * @summary List users in organization (or all users if organizationName not provided)
     * @request GET:/organizations/users
     */
    listUsers: (
      query?: {
        /** Organization name (optional - if not provided, returns all users) */
        organizationName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<User[], any>({
        path: `/organizations/users`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name CreateUser
     * @summary Create user in organization
     * @request POST:/organizations/users
     */
    createUser: (
      query: {
        /** Organization unique name */
        organizationName: string;
      },
      data: User,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organizations/users`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name GetUser
     * @summary Get user
     * @request GET:/organizations/users/user
     */
    getUser: (
      query: {
        /** Organization unique name */
        organizationName: string;
        /** Username */
        username: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<User, void>({
        path: `/organizations/users/user`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name UpdateUser
     * @summary Update user
     * @request PUT:/organizations/users/user
     */
    updateUser: (
      query: {
        /** Organization unique name */
        organizationName: string;
        /** Username */
        username: string;
      },
      data: User,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organizations/users/user`,
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name DeleteUser
     * @summary Delete user
     * @request DELETE:/organizations/users/user
     */
    deleteUser: (
      query: {
        /** Organization unique name */
        organizationName: string;
        /** Username */
        username: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organizations/users/user`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name UpdateUserCredentials
     * @summary Update user's windows credentials
     * @request PUT:/organizations/users/credentials
     */
    updateUserCredentials: (
      query: {
        /** Organization unique name */
        organizationName: string;
        /** Username */
        username: string;
      },
      data: {
        windowsCredentials: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organizations/users/credentials`,
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  permissionGroups = {
    /**
     * No description
     *
     * @tags backoffice
     * @name ListPermissionGroups
     * @summary List permission groups
     * @request GET:/permission-groups
     */
    listPermissionGroups: (params: RequestParams = {}) =>
      this.request<PermissionGroup[], any>({
        path: `/permission-groups`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name CreatePermissionGroup
     * @summary Create permission group
     * @request POST:/permission-groups
     */
    createPermissionGroup: (
      data: PermissionGroup,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/permission-groups`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name UpdatePermissionGroup
     * @summary Update permission group
     * @request PUT:/permission-groups/update
     */
    updatePermissionGroup: (
      query: {
        name: string;
      },
      data: PermissionGroup,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/permission-groups/update`,
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name DeletePermissionGroup
     * @summary Delete permission group
     * @request DELETE:/permission-groups/delete
     */
    deletePermissionGroup: (
      query: {
        name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/permission-groups/delete`,
        method: "DELETE",
        query: query,
        ...params,
      }),
  };
  activities = {
    /**
     * No description
     *
     * @tags backoffice
     * @name ListActivities
     * @summary List activities
     * @request GET:/activities
     */
    listActivities: (
      query?: {
        /**
         * Start of time range (epoch milliseconds)
         * @format int64
         */
        from?: number;
        /**
         * End of time range (epoch milliseconds)
         * @format int64
         */
        to?: number;
        /**
         * Max items to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
        /**
         * Number of items to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /** Filter activities by organization name */
        organization?: string;
        /** Filter activities by username */
        username?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Activity[], any>({
        path: `/activities`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  exceptions = {
    /**
     * No description
     *
     * @tags backoffice
     * @name ListExceptions
     * @summary List exceptions
     * @request GET:/exceptions
     */
    listExceptions: (
      query?: {
        /**
         * Start of time range (epoch milliseconds)
         * @format int64
         */
        from?: number;
        /**
         * End of time range (epoch milliseconds)
         * @format int64
         */
        to?: number;
        /**
         * Max items to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExceptionRecord[], any>({
        path: `/exceptions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  analytics = {
    /**
     * No description
     *
     * @tags backoffice
     * @name GetAnalyticsSummary
     * @summary Analytics summary
     * @request GET:/analytics/summary
     */
    getAnalyticsSummary: (params: RequestParams = {}) =>
      this.request<AnalyticsSummary, any>({
        path: `/analytics/summary`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name GetAnalyticsTrends
     * @summary Activity trends and breakdowns
     * @request GET:/analytics/trends
     */
    getAnalyticsTrends: (
      query?: {
        /**
         * Start of time range (epoch milliseconds)
         * @format int64
         */
        from?: number;
        /**
         * End of time range (epoch milliseconds)
         * @format int64
         */
        to?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          activityTrends?: ActivityTrend[];
          userActivity?: UserActivity[];
          organizationStats?: OrganizationStats[];
        },
        any
      >({
        path: `/analytics/trends`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name GetActivityCounts
     * @summary Get activity counts for different time periods
     * @request GET:/analytics/activity-counts
     */
    getActivityCounts: (params: RequestParams = {}) =>
      this.request<ActivityCounts, any>({
        path: `/analytics/activity-counts`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name GetUserActivitySummary
     * @summary Get user activity summary with last activity times
     * @request GET:/analytics/user-activity-summary
     */
    getUserActivitySummary: (params: RequestParams = {}) =>
      this.request<UserActivitySummary[], any>({
        path: `/analytics/user-activity-summary`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name GetProjectAnalytics
     * @summary Get comprehensive project analytics
     * @request GET:/analytics/projects
     */
    getProjectAnalytics: (
      query?: {
        /**
         * Start date filter (epoch milliseconds)
         * @format int64
         */
        startDate?: number;
        /**
         * End date filter (epoch milliseconds)
         * @format int64
         */
        endDate?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProjectAnalytics, void>({
        path: `/analytics/projects`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  properties = {
    /**
     * No description
     *
     * @tags backoffice
     * @name GetProperties
     * @summary Get AWS properties (minVersion and maxVersion)
     * @request GET:/properties
     */
    getProperties: (params: RequestParams = {}) =>
      this.request<Properties, void>({
        path: `/properties`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name UpdateProperties
     * @summary Update AWS properties (minVersion and maxVersion)
     * @request PUT:/properties
     */
    updateProperties: (data: Properties, params: RequestParams = {}) =>
      this.request<Properties, void>({
        path: `/properties`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  projects = {
    /**
     * No description
     *
     * @tags backoffice
     * @name ListProjects
     * @summary List projects
     * @request GET:/projects
     */
    listProjects: (params: RequestParams = {}) =>
      this.request<Project[], void>({
        path: `/projects`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags backoffice
     * @name GetProject
     * @summary Get project by ID
     * @request GET:/projects/detail
     */
    getProject: (
      query: {
        /** Project ID */
        projectId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Project, void>({
        path: `/projects/detail`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
